import React, { useState } from "react";
import { Button, Modal, Collapse } from "components";
import { ChevronDown, ChevronUp } from "../../../entrypoints/dashboard/layouts/dashboard/sidebar/icons/icons/icons";

import "../index.scss";

const LockIcon = () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M11.3334 7.33594H4.66671C3.93033 7.33594 3.33337 7.93289 3.33337 8.66927V12.6693C3.33337 13.4057 3.93033 14.0026 4.66671 14.0026H11.3334C12.0698 14.0026 12.6667 13.4057 12.6667 12.6693V8.66927C12.6667 7.93289 12.0698 7.33594 11.3334 7.33594Z" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M8.00004 11.3333C8.36823 11.3333 8.66671 11.0349 8.66671 10.6667C8.66671 10.2985 8.36823 10 8.00004 10C7.63185 10 7.33337 10.2985 7.33337 10.6667C7.33337 11.0349 7.63185 11.3333 8.00004 11.3333Z" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M5.33337 7.33333V4.66667C5.33337 3.95942 5.61433 3.28115 6.11442 2.78105C6.61452 2.28095 7.2928 2 8.00004 2C8.70728 2 9.38556 2.28095 9.88566 2.78105C10.3858 3.28115 10.6667 3.95942 10.6667 4.66667V7.33333" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>


const CustomizeCookieModal = ({ isShop, open, close, showCookie, variants, setVariants }) => {

	const [collapsed, showCollapsed] = useState([]);

	const showDetails = (data) => {
		if(collapsed.includes(data)) {
			showCollapsed([...collapsed.filter((i) => i !== data)])
		} else {
			showCollapsed([...collapsed, data])
		}
	}

	const showVariant = (data) => {
		if(variants.includes(data)) {
			setVariants([...variants.filter((i) => i !== data)])
		} else {
			setVariants([...variants, data])
		}
	}

	return <Modal open={open} closeModal={close} className={`paylixecommerce-cookie-modal ${isShop ? 'is-shop' : ''}`}>
		<div className="paylixecommerce-modal-header d-flex justify-content-between">
			<span>Your consent preferences</span><Button variant="secondary" onClick={showCookie}>See full Cookie Policy</Button>
		</div>
		<div className="paylixecommerce-modal-body">
			<div>
				The following panel allows you to customize your consent preferences for any tracking technology used to help us achieve the features and activities described below.
				To learn more about how these trackers help us and how they work, refer to the <span className="underline cursor-pointer" onClick={showCookie}>cookie policy</span>.
				You may review and change your choices at any time.
				Please be aware that denying consent for a particular purpose may make related features unavailable.
			</div>
			<br/><br/>

			<div>
				<div className="paylixecommerce-cookie-modal-details">
					<div>
						<div className="paylixecommerce-cookie-modal-details-title">Strictly necessary</div>
						<div onClick={showDetails.bind(this, 1)}>
							<div>See Description</div>
							{collapsed.includes(1) ? <ChevronUp /> : <ChevronDown />}
						</div>
					</div>

					<div className="d-flex align-items-center">
						<div className="switcher-container">
							<label htmlFor="strictly" className="switcher mr-3">
								<input type="checkbox" disabled id="strictly" name="strictly" checked={variants.includes('strictly')} onChange={() => showVariant('strictly')}/>
								<span className="switcher-slider"/>
								<div className="switcher-container-lock"><LockIcon /></div>
							</label>
						</div>
					</div>

					<Collapse isOpen={collapsed.includes(1)}>
						<div>
							These trackers are used for activities that are strictly necessary to operate or deliver the service you requested from us and, therefore, do not require you to consent.
						</div>
					</Collapse>

				</div>

				<div className="paylixecommerce-cookie-modal-details">
					<div>
						<div className="paylixecommerce-cookie-modal-details-title">Experience enhancement</div>
						<div onClick={showDetails.bind(this, 2)}>
							<div>See Description</div>
							{collapsed.includes(2) ? <ChevronUp /> : <ChevronDown />}
						</div>
					</div>

					<div className="d-flex align-items-center">
						<div className="switcher-container">
							<label htmlFor="experience" className="switcher mr-3">
								<input type="checkbox" id="experience" name="experience" checked={variants.includes('experience')} onChange={() => showVariant('experience')}/>
								<span className="switcher-slider"/>
							</label>
						</div>
					</div>

					<Collapse isOpen={collapsed.includes(2)}>
						<div>
							These trackers help us to provide a personalized user experience by improving the quality of your preference management options, and by enabling the interaction with external networks and platforms.
						</div>
					</Collapse>

				</div>

				<div className="paylixecommerce-cookie-modal-details">
					<div>
						<div className="paylixecommerce-cookie-modal-details-title">Measurement</div>
						<div onClick={showDetails.bind(this, 3)}>
							<div>See Description</div>
							{collapsed.includes(3) ? <ChevronUp /> : <ChevronDown />}
						</div>
					</div>

					<div className="d-flex align-items-center">
						<div className="switcher-container">
							<label htmlFor="measurement" className="switcher mr-3">
								<input type="checkbox" id="measurement" name="measurement" checked={variants.includes('measurement')} onChange={() => showVariant('measurement')}/>
								<span className="switcher-slider"/>
							</label>
						</div>
					</div>

					<Collapse isOpen={collapsed.includes(3)}>
						<div>
							These trackers help us to measure traffic and analyze your behavior with the goal of improving our service.
						</div>
					</Collapse>

				</div>

				<div className="paylixecommerce-cookie-modal-details">
					<div>
						<div className="paylixecommerce-cookie-modal-details-title">Targeting & Advertising</div>
						<div onClick={showDetails.bind(this, 4)}>
							<div>See Description</div>
							{collapsed.includes(4) ? <ChevronUp /> : <ChevronDown />}
						</div>
					</div>

					<div className="d-flex align-items-center">
						<div className="switcher-container">
							<label htmlFor="targeting" className="switcher mr-3">
								<input type="checkbox" id="targeting" name="targeting" checked={variants.includes('targeting')} onChange={() => showVariant('targeting')}/>
								<span className="switcher-slider"/>
							</label>
						</div>
					</div>

					<Collapse isOpen={collapsed.includes(4)}>
						<div>
							These trackers help us to deliver personalized marketing content to you based on your behavior and to operate, serve and track ads.
						</div>
					</Collapse>

				</div>
			</div>

		</div>

		<div className="paylixecommerce-modal-footer d-flex justify-content-between">
			<div className="d-flex">
				<Button variant="secondary" size="large" className="mr-3" onClick={() => setVariants(['strictly', 'experience', 'measurement', 'targeting'])}>Accept All</Button>
				<Button variant="secondary" size="large" onClick={() => setVariants(['strictly'])}>Reject All</Button>
			</div>

			<Button size="large" onClick={close}>Save & Continue</Button>
		</div>
	</Modal>
}

export default CustomizeCookieModal;
